import PropTypes from 'prop-types';

/**
 * AppShell — contenedor responsive que centra el contenido en tablet/desktop
 * y mantiene full-width en mobile/WebView.
 *
 * Variantes:
 *  'default'  → max-w-3xl (md) / max-w-5xl (lg) centrado con padding lateral
 *  'narrow'   → max-w-xl centrado (formularios, onboarding)
 *  'wide'     → max-w-7xl centrado (dashboards, listas)
 *  'full'     → sin restricción de ancho (mapas, medios)
 */
const MAX_WIDTH = {
  // `default` and `wide` share the same desktop ceiling (max-w-5xl ≈ 1024px)
  // so every authenticated screen aligns to one consistent content column.
  // List/card screens fill that width with a responsive grid instead of
  // stretching single rows edge-to-edge.
  default: 'md:max-w-3xl lg:max-w-5xl',
  narrow: 'md:max-w-lg lg:max-w-xl',
  wide: 'md:max-w-3xl lg:max-w-5xl',
  full: '',
};

const AppShell = ({
  children,
  variant = 'default',
  className = '',
  padded = true,
}) => {
  const maxW = MAX_WIDTH[variant] ?? MAX_WIDTH.default;
  const padding = padded ? 'md:px-8 lg:px-12' : '';

  return (
    <div className={`w-full ${maxW} mx-auto ${padding} ${className}`}>
      {children}
    </div>
  );
};

AppShell.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['default', 'narrow', 'wide', 'full']),
  className: PropTypes.string,
  padded: PropTypes.bool,
};

export default AppShell;
